module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9612c07df18f9c381c3.worker.js");
};